module.exports = __webpack_public_path__ + "static/media/repeat.f2e498fc.svg";